// Trustpilot's rating word: 5 Excellent … 1 Bad.
const RATING_LABELS: Readonly<Record<number, string>> = Object.freeze({
  1: 'Bad',
  2: 'Poor',
  3: 'Average',
  4: 'Great',
  5: 'Excellent',
})

export function trustpilotLabel(rating: number): string {
  const stars = Math.round(Math.max(0, Math.min(5, Number(rating) || 0)))
  return RATING_LABELS[stars] ?? ''
}
